import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import './styles.css';

import userService from '../../../services/userServices';

import { FaEyeSlash, FaEye } from 'react-icons/fa'

function ChangePasswordForm(props) {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [passwordConfirmVisibility, setConfirmPasswordVisibility] = useState(false);
    const params = useParams();
    const history = useHistory();


    const onSend = async(e) => {
        e.preventDefault()
        if(password !== confirmPassword)
            alert("A senha digitada deve ser igual nos dois campos!");
        else{
            try{
                const response = await userService.changePassword(password, params.token);
                if (response.status >= 400)
                    alert("Não foi possível trocar sua senha, solicite novamente o envio de um email na tela de login");
                else
                    alert("Sua senha foi trocada com sucesso!");
                history.push("/");
            } catch (err) {
                alert(err.message);
            }
        }
    }

    const onChangePassword = (e) => {
        setPassword(e.target.value);
    }

    const onChangeConfirmPassword = (e) => {
        setConfirmPassword(e.target.value);
    }

    return (
        <form onSubmit={onSend} className={'new-password-form' + (props.hide ? ' none-opacity' : '')}>
            <h1>Nova senha</h1>

            <label htmlFor="password">Senha</label>
            <div className='new-password-form-password-input'>
                <input
                    required
                    onChange={onChangePassword}
                    value={password}
                    placeholder='Insira a nova senha aqui'
                    type={passwordVisibility ? 'text' : 'password'}
                    id="password"
                />
                <button type="button" className="hide-new-password-icon" onClick={() => setPasswordVisibility(!passwordVisibility)}>
                    {passwordVisibility ?
                        <FaEyeSlash size={16} color="#B2BFD8" />
                        :
                        <FaEye size={16} color="#B2BFD8" />
                    }
                </button>
            </div>

            <label htmlFor="confirm-password">Confirmação de senha</label>
            <div className='new-password-form-password-input'>
                <input
                    required
                    onChange={onChangeConfirmPassword}
                    value={confirmPassword}
                    placeholder='Insira a senha novamente'
                    type={passwordConfirmVisibility ? 'text' : 'password'}
                    id="confirm-password"
                />
                <button type="button" className="hide-new-password-icon" onClick={() => setConfirmPasswordVisibility(!passwordConfirmVisibility)}>
                    {passwordConfirmVisibility ?
                        <FaEyeSlash size={16} color="#B2BFD8" />
                        :
                        <FaEye size={16} color="#B2BFD8" />
                    }
                </button>
            </div>

            <button type='submit' className='new-password-button'>Enviar</button>
        </form>
    );

}

export default ChangePasswordForm;